'use strict';

/* globals $ */

var React = require('react');

var DateTime = require('./date.jsx');
var at = require('../../utils/environment');


var Header = React.createClass({

    componentDidMount: function() {
        var $chapeu = (window.$ && $(this.refs.chapeu));
        if ($chapeu && $chapeu.height() > 21) $chapeu
            .addClass('feed-chapeu-shrunken')
            .attr('title', this.props.content.chapeu.label);
    },

    renderChapeu: function() {
        var url = this.props.content.chapeu.url;
        var label = this.props.content.chapeu.label;
        var props = {
            ref: 'chapeu',
            className: 'feed-post-header-chapeu gui-text-section-title'
        };

        if (url) return <a {...props} href={url}>{label}</a>;
        else return <span {...props}>{label}</span>;
    },

    renderTime: function() {
        if (at.client && !this.props.isRecommended)
            return <DateTime time={this.props.age*1000} />;
        else return null;
    },

    render: function() {
        return (
            <span className='feed-post-header'>
                {this.renderChapeu()}
                {this.renderTime()}
            </span>
        );
    }
});

module.exports = Header;
